import { jsx as _jsx } from "react/jsx-runtime";
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const TermsOfService = () => {
    return (_jsx("a", { href: txt('aiTermsLink'), target: "_blank", rel: "noreferrer", className: styles.link, children: txt('aiTermsOfService') }));
};
export default TermsOfService;
